<script setup>
defineProps({
  item: {
    type: Object,
    default: () => ({
      imageUrl: null
    }),
    required: true
  }
})
</script>

<template>
  <div class="relative">
    <img
      :src="item.imageUrl"
      class="aspect-square w-full"
      alt="Gift">

    <span
      v-if="item.priceInCredits === 0"
      class="absolute -bottom-1 -right-1 text-gray-400 text-xs">
      Free
    </span>

    <span
      v-else-if="item.priceInCredits"
      class="absolute -bottom-1 -right-1 text-gray-400 text-xs">
      {{ item.priceInCredits }}
    </span>
  </div>
</template>